import { DomainError } from './domainError.util';
import { ErrorCode, ErrorContext } from './errorCatalog';

export declare type FunctionsErrorCode =
  'ok'
  | 'cancelled'
  | 'unknown'
  | 'invalid-argument'
  | 'deadline-exceeded'
  | 'not-found'
  | 'already-exists'
  | 'permission-denied'
  | 'resource-exhausted'
  | 'failed-precondition'
  | 'aborted'
  | 'out-of-range'
  | 'unimplemented'
  | 'internal'
  | 'unavailable'
  | 'data-loss'
  | 'unauthenticated';

export declare type ErrorChannel =
  | 'STANDARD'
  | 'GENIUS'
  | 'CRITICAL'
  | 'INPUT'
  | 'SUPPORT'
  | 'SERVICES'
  | 'AUTH';

export type ManageErrorArgument = {
  code: FunctionsErrorCode,
  message: string,
  verbose?: boolean,
  statusCode?: number,
  channel?: ErrorChannel,
  context?: unknown,
  /** Structured error code from the catalog — surfaced in HttpsError.details.customCode */
  customCode?: ErrorCode,
  /** Upstream error that triggered this one — preserves the trace chain in logs and downstream listeners */
  cause?: unknown,
};

/** Typed overload: when `customCode` is a catalog key, `context` shape is inferred and enforced. */
export function manageError<K extends ErrorCode>(
  args: Omit<ManageErrorArgument, 'customCode' | 'context'> & {
    customCode: K;
    context: ErrorContext<K>;
  },
): never;
export function manageError(args: ManageErrorArgument): never;
export function manageError({
  code,
  message,
  verbose = true,
  statusCode = 500,
  channel = 'STANDARD',
  context,
  customCode,
  cause,
}: ManageErrorArgument): never {
  if (verbose) {
    console.error(message, context !== undefined ? { context } : undefined, cause);
  }
  throw new DomainError(message, code, statusCode, channel, { customCode, context, cause });
}
